<template>
  <div class="home">
    <Header class="header-style"/>
    <router-view />
    <Footer />
  </div>
</template>

<script>
const Header = () => import("../components/header.vue");
const Footer = () => import("../components/footer.vue");
export default {
  name: "Home",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      active: "0",
    };
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.home{
  min-width: 1000px;
	position: relative;
	.header-style{
		position: sticky;
		left: 0;
		top: 0px;
		overflow: hidden;
		z-index: 9999;
}
}

</style>
